import React, { Component } from 'react';
import { connect } from 'react-redux';
import { safeGet, safeGetWithType } from 'iotera-base/json';
import { setDeviceEmpty } from '../../../testActions';
import { store } from '../../../testStore';
import { withRouter } from 'react-router-dom';
import { domainIsTenant, S } from '../../../routes/routes';

import { buildWBoundActions, buildWSelector } from '../../../redux/ducks';
import { actions as notificationActions } from '../../../redux/ducks/notification';
import { actions as modalActions } from '../../../redux/ducks/modal';

import { SubViewHeader } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { IoteraForm } from '../../../lib/components/form';
import { upperFirstLetter } from '../../../lib/components/formatter';
import { TextInputTag } from '../../../lib/components/textInputTag';
import { isNumber, isEmpty } from 'iotera-base/object';
import Result from 'iotera-base/result';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../lib/components/callbackGlobal';

const INIT_TAGS = 'INIT_TAGS';
const INIT_DEV = 'INIT_DEV';
const EDIT = 'EDIT';
const WKEY = 'EDIT_TAG';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function schema(properties) {
  return {
    title: 'Pilih penanda yang akan dipakai dalam perangkat',
    type: 'object',
    required: [],
    properties,
  };
}

function RemoveArrayFromArray(arrCore, arrToRemove) {
  for (let j = 0; j < arrToRemove.length; j++) {
    let index = arrCore.indexOf(arrToRemove[j]);
    if (index > -1) {
      arrCore.splice(index, 1);
    }
  }
  return arrCore;
}

class Example extends Component {
  constructor(props) {
    super(props);
    const deviceId = safeGetWithType(
      this,
      ['props', 'match', 'params', 'id'],
      '',
    );
    this.state = {
      value: [],
      formData: {},
      tagInc: [],
      values: '',
      loading: false,
      deviceId,
      prevPath: '',
      multiTags: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleCustomChangeForm = this.handleCustomChangeForm.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const { deviceId } = _state;
    if (isEmpty(deviceId)) {
      return {};
    }
    const wsKey = WKEY + '_' + deviceId;
    const dit = domainIsTenant(_props);
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      requests: {
        [INIT_TAGS]: {
          wparam: { ...dit, path: '/service/web/tag/category/get/all' },
          wcallback: {
            started: function (id) {
              // TODO Loading
            },
            finished: function (id, result) {
              // TODO Loading
              _this.setState({
                loading: false,
                tags: safeGetWithType(result, ['body', 'categories'], {}),
              });
            },
          },
        },
        [INIT_DEV]: {
          wparam: { ...dit, path: '/service/web/device/get/id/' + deviceId },
          wcallback: {
            started: function (id) {
              // TODO Loading
            },
            finished: function (id, result) {
              // TODO Loading
            },
          },
          wreducer: {
            rparse: function (id, result, rpayload) {
              let _state = {};
              let _stateForm = {};
              let device = { ...rpayload };
              let tags = device.tags;
              let tagAll = {...safeGetWithType(_this.state, ['tags'], {}),};
              const tagAllMap = {}
              for (let key in tagAll) {
                let tagValue = tagAll[key];
                tagAllMap[tagValue.prefix] = tagValue;
              }
              for (let key in tags) {
                let tagValue = tags[key];
                let tagCategory = safeGet(tagAllMap, [key, 'category'])
                let value = undefined;
                if (tagCategory === 4) {
                  value = tagValue;
                  let multiTags = safeGetWithType(_state, ['multiTags'], []);
                  multiTags.push(key);
                  let newMultiTags = [...new Set(multiTags)];
                  Object.assign(_state, {
                    [key]: value,
                    multiTags: newMultiTags,
                  });
                  continue;
                } else {
                  value = tagValue[0];
                  if (value === 'true') {
                    value = true;
                  } else if (value === 'false') {
                    continue;
                  }
                }
                Object.assign(_stateForm, {
                  [key]: value,
                });
              }
              Object.assign(_state, {
                formData: _stateForm,
                loading: false,
              });
              let deviceTemp = {};
              let ids = device['id'];
              deviceTemp.__id = ids;
              deviceTemp.tags = device['tags'];
              _this.setState(_state);
              return deviceTemp;
            },
          },
        },
      },
    });
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...dit,
            method: 'POST',
            path: '/service/web/device/edit',
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR,
                );
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false,
                  });
                  let action = setDeviceEmpty();
                  store.dispatch(action);
                  _props.history.push('..' + S + '..' + S + '_device_list_');
                  _props.showSingleNotification({
                    message: 'Edit Perangkat Sukses',
                    level: 'success',
                  });
                  return;
                }
              }
              _this.setState({
                loading: false,
              });
              _props.showSingleNotification({
                message: 'Edit Perangkat Gagal',
                position: 'tr',
                level: 'error',
              });
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const deviceId = safeGetWithType(_state, ['deviceId'], '');
    if (isEmpty(deviceId)) {
      return {};
    }
    // callback global
    unsetCallbackGlobal(_props);
    _props.wUnsetConfig({ key: WKEY });
  }

  componentWillReceiveProps(nextProps) {
    const _this = this;
    const _props = _this.props;
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location });
    }
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    let dataForm = event.formData;
    let dataToSubmit = {};
    for (let core in dataForm) {
      let value = [];
      let dataValue = dataForm[core];
      if (dataValue === true) {
        dataValue = 'true';
      }
      if (dataValue === undefined || dataValue === false) {
        continue;
      }
      value.push(dataValue);
      Object.assign(dataToSubmit, {
        [core]: value,
      });
    }
    const multiTags = safeGetWithType(_state, ['multiTags'], []);
    let finalDataObj = {};
    let multiDataObj = {};
    for (let j = 0; j < multiTags.length; j++) {
      let tagPrefix = multiTags[j];
      let value = safeGetWithType(_state, [tagPrefix], []);
      if (value.length <= 0) {
        continue;
      }
      if (value === undefined) {
        continue;
      }
      Object.assign(multiDataObj, {
        [tagPrefix]: value,
      });
    }
    finalDataObj = { ...dataToSubmit, ...multiDataObj };
    const id = safeGetWithType(_props, ['deviceId'], '');
    const wsKey = WKEY + '_' + id;
    _this.setState({
      loading: true,
    });
    Object.keys(finalDataObj).forEach(key => {
      if (finalDataObj[key] === undefined) {
        delete finalDataObj[key];
      } else if (finalDataObj[key] === false) {
        delete finalDataObj[key];
      }
    });
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id,
        tags: finalDataObj,
      },
    });
  }

  goTo(link) {
    this.props.history.push(link);
  }

  goBack() {
    this.props.history.goBack();
  }

  handleChangeArr = (id, prefix, event) => {
    const _this = this;
    const _state = _this.state;
    let multiTags = safeGetWithType(_state, ['multiTags'], []);
    multiTags.push(id);
    let newMultiTags = [...new Set(multiTags)];
    _this.setState({ [id]: event, multiTags: newMultiTags });
  };

  handleValidateArr = tag => {
    const _props = this.props;
    let value = tag[0];
    let firstChar = parseInt(value.charAt(0), 10);
    if (isNumber(firstChar)) {
      _props.showSingleNotification({
        message: 'Penanda tidak boleh diawali oleh angka!',
        level: 'error',
      });
    } else if (value.length > 16) {
      _props.showSingleNotification({
        message: 'Penanda maksimal 16 karakter!',
        level: 'error',
      });
    } else {
      _props.showSingleNotification({
        message: 'Penanda tidak boleh mengandung huruf kapital!',
        level: 'error',
      });
    }
  };

  // To Get Change on IoteraForm
  handleCustomChangeForm = () => event => {
    this.setState({
      formData: event.formData,
    });
  };

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    let items = safeGet(_props, ['items']);
    let { formData: dataToShow } = _state;
    let tagImport = safeGetWithType(_state, ['tagInc'], []);
    let tagNotImport = [];
    let propertiesSchema = {};
    let propertiesUiSchema = {};
    let multiArr = {};
    for (let core in items) {
      let item = items[core];
      let itemId = item.id;
      let itemName = upperFirstLetter(item.name);
      let cat = item.category;
      let itemPrefix = item.prefix;
      let definitions = safeGet(item, 'definitions', []);
      if (cat === 1) {
        let definitionsValueArray = [];
        tagNotImport.push(itemPrefix);
        if (definitions.length === 0) {
          continue;
        }
        for (let z = 0; z < definitions.length; z++) {
          let definitionsValue = {};
          let valueToSubmit = [definitions[z].name_lc];
          definitionsValue.type = 'string';
          definitionsValue.enum = valueToSubmit;
          definitionsValue.title = definitions[z].name;
          definitionsValueArray.push(definitionsValue);
        }
        Object.assign(propertiesSchema, {
          [itemPrefix]: {
            title: itemName,
            type: 'string',
            anyOf: definitionsValueArray,
          },
        });
      } else if (cat === 2) {
        tagNotImport.push(itemPrefix);
        Object.assign(propertiesSchema, {
          [itemPrefix]: {
            title: itemName,
            type: 'string',
          },
        });
      } else if (cat === 3) {
        tagNotImport.push(itemPrefix);
        Object.assign(propertiesSchema, {
          [itemPrefix]: {
            title: itemName,
            type: 'boolean',
          },
        });
        Object.assign(propertiesUiSchema, {
          [itemId]: {},
        });
      } else if (cat === 4) {
        tagNotImport.push(itemPrefix);
        Object.assign(multiArr, {
          [itemPrefix]: item,
        });
      }
    }
    tagNotImport = RemoveArrayFromArray(tagNotImport, tagImport);
    let inputArr = [];
    let pattern = new RegExp('^[a-z][a-z0-9_ ]{0,15}$'); // regex min 1 char, first letter not number, max length 15
    for (let key in multiArr) {
      let prefix = multiArr[key].prefix;
      let name = multiArr[key].name;
      let tags = safeGet(_state, [key], []);
      let customPlaceholder = 'Tambah pilihan';
      if (tags.length > 2) {
        customPlaceholder = '(maksimum 3)';
      }
      inputArr.push(
        <TextInputTag
          id={key}
          value={tags}
          label={name}
          prefix={prefix}
          onChange={this.handleChangeArr.bind(this)}
          pattern={pattern}
          maxTags={3}
          onlyUnique={true}
          addKeys={[9, 13, 32]}
          placeholder={customPlaceholder}
          onValidationReject={this.handleValidateArr.bind(this)}
          preventSubmit={false}
          textTooltip={
            'Tiap penanda harus unik, tidak mengandung huruf besar, tidak diawali angka, maksimum 16 karakter.'
          }
        />,
      );
    }
    return (
      <div className="view">
        <SubViewHeader
          title="Edit Perangkat"
          subTitle="Permohonan edit penanda dari perangkat"
        />
        <div className="io-container mt-12">
          <IoteraForm
            schema={schema(propertiesSchema)}
            uiSchema={propertiesUiSchema}
            formData={dataToShow}
            onChange={_this.handleCustomChangeForm()}
            onSubmit={_this.handleSubmit}
            style={{ marginBottom: 0 }}
          >
            {inputArr}
            <div className="button-right" style={{ marginTop: 20 }}>
              <Button
                variant="outlined"
                size="large"
                style={{ minWidth: '0%' }}
                onClick={() => _this.goBack()}
              >
                Batal
              </Button>
              <Button
                variant="contained"
                size="large"
                color="primary"
                type="submit"
                style={{ marginLeft: 10, minWidth: '0%' }}
              >
                Simpan
              </Button>
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    device: wSelector.getMappedRPayload(state, INIT_DEV),
    deviceId: wSelector.getMappedRPayload(state, INIT_DEV, '__id'),
    items: wSelector.getMappedRPayload(state, INIT_TAGS, 'categories'),
  };
};

const mapDispatchToProps = dispatch => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Example));
